import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CompactViewDialogComponent, DialogInsService } from '@skylab-angular-shared/ui';

export interface ServiceCompactViewItem<TEntity> {
    label: string;
    value: string;
    key: keyof TEntity;
}

@Component({
    template: '',
})
export abstract class ServiceCompactViewItemComponentBase<TEntity = unknown> {
    @Input() public entity!: TEntity;
    @Output() public contextButtonClicked = new EventEmitter();

    protected constructor(
        protected readonly dialogService: DialogInsService
    ) { }

    public ngOnInit(): void {
        this.items = this.itemsConfig;
    }

    public items!: ServiceCompactViewItem<TEntity>[];
    public abstract get itemsConfig(): ServiceCompactViewItem<TEntity>[];

    public getItem(key: keyof TEntity): ServiceCompactViewItem<TEntity>{
        return this.items.find(elem => elem.key === key) || {key, label: '', value: ''};
    }

    public onContextButtonClicked(event: Event): void {
        this.contextButtonClicked.emit({event, entity: this.entity});
    }

    public openDetailsDialog(): void {
        this.dialogService.showAsync({
            component: CompactViewDialogComponent,
            componentProps: {
                data: {
                    items: this.items,
                    title: this.items.find(elem => elem.key === this.headerTitleProp)?.value || ''
                }
            }
        });
    }

    protected abstract get headerTitleProp(): keyof TEntity;
}
